"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _useProgressTween = require("web/shared/icons/useProgressTween");
var _ImageCandidateActions = require("web/shared/imageCandidates/ImageCandidateActions.styles");
var _imageCandidateWording = require("web/shared/imageCandidates/imageCandidateWording");
var _toast = require("web/shared/utils/toast");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The "Selected" mark: what stands where the choose control would on the
* candidate that is shown. Whole from the start on one that was already
* chosen; landing with its check drawing in, base to tip, on one just
* chosen. A tap on it changes nothing and says so, as a toast.
*/ // The checkmark's cycle erases to nothing at 0.5 and is whole again at 1,
// so drawing in is the run from the empty half to the end.
const EMPTY = 0.5;
const WHOLE = 1;
function ChosenMark(props) {
  const wording = (0, _imageCandidateWording.useImageCandidateWording)();
  const _useState = (0, _react.useState)(props.drawIn ? EMPTY : 0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    target = _useState2[0],
    setTarget = _useState2[1];
  (0, _react.useEffect)(() => {
    if (props.drawIn) {
      setTarget(WHOLE);
    }
  }, [props.drawIn]);
  const progress = (0, _useProgressTween.useProgressTween)(target, 480);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
    type: "button",
    "aria-pressed": "true",
    title: wording.alreadyChosen,
    onClick: () => (0, _toast.showToast)(wording.alreadyChosen)
  }, stylex.props(_ImageCandidateActions.styles.action, _ImageCandidateActions.styles.chosenMark, props.drawIn && _ImageCandidateActions.styles.chosenMarkIn)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
      name: "checkmark",
      size: "s",
      progress: progress
    }), "Selected"]
  }));
}
var _default = exports.default = ChosenMark;